// src/components/FilterButton.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function FilterButton({ style = {}, showLabel = true }) {
  const nav = useNavigate();
  return (
    <button
      onClick={() => nav('/filters')}
      title="Відкрити фільтр"
      aria-label="Відкрити фільтр"
      style={{
        height: 42,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: showLabel ? 10 : 0,
        padding: showLabel ? '0 14px' : '0 10px',
        borderRadius: 999,
        border: '1px solid rgba(255,255,255,.35)',
        background: 'rgba(255,255,255,.15)',
        color: '#fff',
        backdropFilter: 'blur(4px)',
        cursor: 'pointer',
        fontWeight: 700,
        lineHeight: 1,
        ...style,
      }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="6" width="18" height="2" rx="1" fill="currentColor" />
        <rect x="3" y="11" width="18" height="2" rx="1" fill="currentColor" />
        <rect x="3" y="16" width="18" height="2" rx="1" fill="currentColor" />
      </svg>
      {showLabel && <span>Фільтр</span>}
    </button>
  );
}
